const targetElement = document.querySelector(".full-header"),
  searchContent = document.querySelector('.search-card');
window.addEventListener("scroll", () => {
  if (window.scrollY > 100) {
    targetElement.classList.add("fixed");
    searchContent.classList.add("isScrolling");
  } else {
    targetElement.classList.remove("fixed");
    searchContent.classList.remove("isScrolling");
  }
});
